import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import MissionStatement from '@/components/MissionStatement';
import VisionStatement from '@/components/VisionStatement';
import HistorySection from '@/components/HistorySection';
import AnthemSection from '@/components/Anthem';

const About = () => {
  const location = useLocation();

  const historyRef = useRef<HTMLDivElement>(null);
  const missionVisionRef = useRef<HTMLDivElement>(null);
  const anthemRef = useRef<HTMLDivElement>(null);

  // Scroll to section on route change
  useEffect(() => {
    const path = location.pathname;

    if (path.includes('/about/history') && historyRef.current) {
      historyRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (path.includes('/about/vision-mission') && missionVisionRef.current) {
      missionVisionRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (path.includes('/about/anthem') && anthemRef.current) {
      anthemRef.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-50 pt-16 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-16">
          <h1 className="text-4xl lg:text-5xl font-extrabold text-gray-800 mb-4">
            About Our Diocese
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Learn about our origin, core beliefs, and anthem that unites us.
          </p>
        </header>

        {/* Section: History */}
        <section ref={historyRef} className="mb-20">
          <HistorySection />
        </section>

        {/* Section: Vision & Mission */}
        <section ref={missionVisionRef} className="mb-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <VisionStatement />
            <MissionStatement />
          </div>
        </section>

        {/* Section: Anthem */}
        <section ref={anthemRef}>
          <AnthemSection />
        </section>
      </div>
    </div>
  );
};

export default About;
